import React from 'react';
import ReactDOM from 'react-dom/client';
// Sarv design system — load once, in order, before app CSS so tokens/fonts
// are available and app styles can override where needed.
import './theme/fonts.css';
import './theme/design-system.css';
import './index.css';
import './theme-compat.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
